import { useState } from "react";
import axios from "axios";
import { Container, Accordion, Table, Button } from "react-bootstrap";

export default function BulkLoadExams() {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const RESPONSE_OK = "OK";
  const MAX_COLUMNS = 5;
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [array, setArray] = useState([]);

  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));
  const fileReader = new FileReader();

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        csvFileToArray(text);
      };

      fileReader.readAsText(file);
    }
  };

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");
    let array = csvRows.map((i) => {
      let row = i.split(";");
      row = row.map((e) => {
        return e.trim();
      });
      row[row.length] = "A procesar";
      return row;
    });
    array = array.filter((row) => row && row.length === MAX_COLUMNS + 1);
    setArray(array);
  };

  const saveData = (e) => {
    e.preventDefault();
    setLoading(true);
    Promise.all(
      array.map(async (item) => {
        if (item[MAX_COLUMNS] !== RESPONSE_OK) {
          const reqExam = {
            data: {
              docNumber: item[0],
              date: item[1],
              grade_id: item[2],
              dojo_id: item[3],
              responsibleDocNumber: item[4],
              state: "NEW",
              createdByUser: usuario.id,
            },
          };
          await axios
            .post(`${API_URL}/temp-exams`, reqExam, headerRequest)
            .then(() => {
              item[MAX_COLUMNS] = RESPONSE_OK;
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error with post temp-exams:", error.response);
              item[MAX_COLUMNS] = "ERROR";
            });
        }
        return item;
      })
    )
      .then((items) => setArray(items))
      .finally(() => {
        setLoading(false);
      });

    // setLoading(false);
    // setArray({ ...array });
    // console.log({ array });
  };

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>CARGA MASIVA EXÁMENES</h4>
      <p>Seleccione un archivo CSV según corresponda e importe los datos.</p>

      <div style={{ textAlign: "center" }}>
        <Accordion
          style={{ maxWidth: "400px", margin: "0 auto" }}
          className="p-1 mb-4"
          flush
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>Ejemplo de Formato del archivo</Accordion.Header>
            <Accordion.Body style={{ textAlign: "left" }}>
              DNI;FECHA;GRADUACIÓN;DOJO;SENSEI
              <br />
              20168702;2000-12-01;9;1;8519212
              <br />
              22008944;2000-05-31;10;2;8519212
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <form>
          <input
            type={"file"}
            id={"fileInput"}
            accept={".csv"}
            onChange={handleOnChange}
          />
          <Button
            size="sm"
            variant="success"
            disabled={isLoading}
            onClick={(e) => {
              handleOnSubmit(e);
            }}
          >
            CARGAR
          </Button>
        </form>
      </div>
      {array.length > 0 ? (
        <>
          <Table striped hover size="sm" className="mt-3" responsive="sm">
            <thead>
              <tr>
                <th>DNI</th>
                <th>Fecha</th>
                <th>Graduación</th>
                <th>Dojo</th>
                <th>Responsable</th>
                <th>Resultado</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="6">Leyendo....</td>
                </tr>
              ) : (
                array.map((item, i) => (
                  <tr key={i}>
                    {Object.values(item).map((val) => (
                      <td>{val}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </Table>
          <Button
            size="sm"
            variant="success"
            disabled={isLoading}
            onClick={(e) => {
              saveData(e);
            }}
          >
            IMPORTAR
          </Button>
        </>
      ) : null}
    </Container>
  );
}
